class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.init();
    this.attachEventListeners();
  }

  attachEventListeners() {
    this.buttonClose = this.querySelector(".js-button-close");
    this.buttonClose.addEventListener("click", this.closeNewsletter.bind(this));

    if (this.form) {
      this.form.addEventListener("submit", this.onSubscribe.bind(this));
    }
  }

  init() {
    this.delay = this.dataset.delay * 1000;
    this.closed = getCookie("newsletter-closed");
    this.subscribed = getCookie("newsletter-subscribed");
    this.form = this.querySelector(".js-form");
    this.ageVerificationPopup = document.querySelector("age-verification-popup");
  }

  closeNewsletter() {
    setCookie("newsletter-closed", "true");
    this.hide();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") {
      this.show();
      }
      return;
    }

    this.handlePopupVisibility();
  }

  handlePopupVisibility() {
    if (getCookie("age-verified") !== "true" && this.ageVerificationPopup) {
      this.handleAgeVerificationPopup();
    } else {
      this.showPopupWithDelay();
    }
  }

  handleAgeVerificationPopup() {
    let prevClassState = this.classList.contains("newsletter-popup-is-hidden");

    const observer = new MutationObserver(mutations => {
      const mutation = mutations[0];
      if (mutation.attributeName !== "class") return;

      const currentClassState = mutation.target.classList.contains("newsletter-popup-is-hidden");

      if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;
        if (!currentClassState) {
          this.showPopupWithDelay();
        }
      }
    });

    observer.observe(this, { attributes: true });
  }

  // Boneswimmer: the popup used to open on top of the cookie banner, the menu and the cart drawer.
  // It now waits for the delay, then opens only when no banner or drawer is on screen, retrying a few
  // times; it never opens on cart, checkout or policy pages.
  somethingElseIsOpen() {
    const banner = document.querySelector("#shopify-pc__banner, .shopify-pc__banner, [data-cookie-banner], #cookie-banner, .cookie-banner");
    if (banner && !banner.hidden && banner.offsetParent !== null) return true;
    if (document.body.style.overflow === "hidden" || document.body.classList.contains("overflow-hidden")) return true;
    if (document.querySelector(".drawer.active, .drawer.is-open, .drawer[open], details[open] > summary[aria-expanded='true']")) return true;
    return false;
  }

  showPopupWithDelay() {
    if (this.closed === "true" || this.subscribed === "true") return;
    if (/\/(cart|checkouts?|policies|pages\/(cambi-e-resi|spedizioni-e-consegne|contatti))/.test(window.location.pathname)) return;
    let attempts = 0;
    const tryShow = () => {
      attempts += 1;
      if (this.somethingElseIsOpen()) {
        if (attempts < 4) setTimeout(tryShow, 15000);
        return;
      }
      this.show();
    };
    setTimeout(tryShow, this.delay);
  }

  onSubscribe() {
    setCookie("newsletter-subscribed", "true");
    this.hide();
  }
}

customElements.define("newsletter-popup", NewsletterPopup);
